/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-unresolved */
import { Button } from "@mui/material";
import { useFormik } from "formik";
import { memo, useEffect, useLayoutEffect, useState } from "react";
import {
  jointMedicalInitialValues,
  jointMedicalValidationSchema
} from "src/helpers/FormDetails/JointLifeAddendum";
import {
  displayAdditionalQue,
  getQuestionnaireMapper
} from "src/helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle/mapper";
import {
  calcAgeFromToday,
  checkMedicalField
} from "src/helpers/FormDetails/ProposalDetails/resources";
import { products } from "src/helpers/FormDetails/resources";
import { setStepDetails } from "src/redux/Actions/common";
import { setJointMedicalLifestylePostDetails } from "src/redux/Thunk";
import store from "src/redux/store";
import ConfirmationModal from "src/shared/ConfirmationModal";
import CustomModal from "src/shared/CustomModal";
import MedicalAndLifestyle from "src/shared/MedicalLifeStyle";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

function JoinLifeMedicalLifestyle() {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [smokerError, setSmokerError] = useState<boolean>(false);
  const [alcoholError, setAlcoholError] = useState<boolean>(false);
  const [frequencyError, setfrequencyError] = useState<boolean>(false);
  // const jointLifeMecialLifestyleDetails = useAppSelector(
  //   (state) => state.jointLifeAddendum.medicalDetails
  // );
  const jointLifeMecialLifestyleDetails = useAppSelector((state) => state.jointLifeAddendum);
  // const leadId = useAppSelector((state) => state.common.leadId);
  // const tableData = useAppSelector((state) => state.dashboard.tableData);
  const jointLifeMemberDetails = useAppSelector((state) => state.jointLifeAddendum.member);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const jointStepNo = useAppSelector((state) => state.stepDetails?.jointStepNo);
  const parentStepNumber = useAppSelector((state): any => state.stepDetails.parentStepNo);

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const productId = useAppSelector((state) => state.common.leadDetails?.productId);
  const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId)!;

  const medicalQuestions = getQuestionnaireMapper(productId, partnerId);

  // TODO: remove the logic from here and pass as a prop
  const sumAssured = useAppSelector((state) => state?.common?.leadDetails?.sumAssured);
  const jointLifeDob = useAppSelector((state) => state?.jointLifeAddendum?.member?.dob) || "";
  const toDisplayAdditionalQue = displayAdditionalQue(sumAssured, jointLifeDob);
  const age = calcAgeFromToday(jointLifeDob);
  const nationality = useAppSelector((state) => state.jointLifeAddendum?.member?.nationalityCode);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: jointLifeMecialLifestyleDetails || jointMedicalInitialValues,
    validationSchema: jointMedicalValidationSchema(productId, age, partnerId),
    onSubmit: (fieldValues) => {
      const nextStepDetails =
        nationality !== "RES"
          ? { jointStepNo: jointStepNo + 1 }
          : { parentStepNo: parentStepNumber + 1 };
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(
          setJointMedicalLifestylePostDetails(fieldValues?.medicalDetails, nextStepDetails)
        );
        window.scrollTo(0, 0);
      }
    }
  });

  useEffect(() => {
    if (jointLifeMemberDetails.gender === "Male") {
      formik.setFieldValue("medicalDetails.gyneComplications", false);
    }
  }, []);

  // useLayoutEffect(() => {
  //   formik.setValues({
  //     medicalDetails: jointLifeAddendum
  //   });
  // }, []);

  useEffect(() => {
    // console.log("joint formik", formik);
    if (!formik.values.medicalDetails.alcohol) {
      setAlcoholError(false);
      setfrequencyError(false);
      formik.setFieldValue("medicalDetails.beer", false);
      formik.setFieldValue("medicalDetails.wine", false);
      formik.setFieldValue("medicalDetails.liquor", false);
      formik.setFieldValue("medicalDetails.once", false);
      formik.setFieldValue("medicalDetails.daily", false);
      formik.setFieldValue("medicalDetails.moreThanOnce", false);
      formik.setFieldValue("medicalDetails.lessThanOnce", false);
      formik.setFieldValue("medicalDetails.alcoholAmount", "");
      formik.setFieldValue("medicalDetails.alcoholConsumptionSince", 0);
    }
  }, [formik.values.medicalDetails.alcohol]);

  useLayoutEffect(() => {
    const { beer, wine, liquor, once, lessThanOnce, moreThanOnce, daily } =
      formik.values.medicalDetails;

    if (!((beer || wine || liquor) && (once || lessThanOnce || moreThanOnce || daily))) {
      formik.setFieldValue("medicalDetails.alcoholAmount", "");
    }
  }, [
    formik.values.medicalDetails.beer,
    formik.values.medicalDetails.wine,
    formik.values.medicalDetails.liquor,
    formik.values.medicalDetails.once,
    formik.values.medicalDetails.lessThanOnce,
    formik.values.medicalDetails.moreThanOnce,
    formik.values.medicalDetails.daily
  ]);

  useLayoutEffect(() => {
    if (!formik.values.medicalDetails?.pregnant) {
      formik.setFieldValue("medicalDetails.pregnancyDuration", "");
    }
  }, [formik.values.medicalDetails.pregnant]);

  useEffect(() => {
    // console.log("joint formik", formik);
    if (!formik.values.medicalDetails.smoker) {
      setSmokerError(false);
      formik.setFieldValue("medicalDetails.bidi", false);
      formik.setFieldValue("medicalDetails.bidiAmount", "");
      formik.setFieldValue("medicalDetails.cigaratteAmount", "");
      formik.setFieldValue("medicalDetails.cigaratte", false);
      formik.setFieldValue("medicalDetails.gutkhaAmount", "");
      formik.setFieldValue("medicalDetails.gutkha", false);
      formik.setFieldValue("medicalDetails.chewing", false);
      formik.setFieldValue("medicalDetails.chewingAmount", "");
      formik.setFieldValue("medicalDetails.cigar", false);
      formik.setFieldValue("medicalDetails.cigarAmount", "");
      formik.setFieldValue("medicalDetails.panMasala", false);
      formik.setFieldValue("medicalDetails.panMasalaAmount", "");
      formik.setFieldValue("medicalDetails.smokingConsumptionSince", 0);
    }
  }, [formik.values.medicalDetails.smoker]);

  useEffect(() => {
    if (
      formik.values.medicalDetails.bidi ||
      formik.values.medicalDetails.cigaratte ||
      formik.values.medicalDetails.gutkha ||
      formik.values.medicalDetails.chewing ||
      formik.values.medicalDetails.cigar ||
      formik.values.medicalDetails.panMasala
    ) {
      setSmokerError(false);
    }
  }, [
    formik.values.medicalDetails.bidi ||
      formik.values.medicalDetails.cigaratte ||
      formik.values.medicalDetails.gutkha ||
      formik.values.medicalDetails.chewing ||
      formik.values.medicalDetails.cigar ||
      formik.values.medicalDetails.panMasala
  ]);
  useEffect(() => {
    if (
      formik.values.medicalDetails.beer ||
      formik.values.medicalDetails.wine ||
      formik.values.medicalDetails.liquor
    ) {
      setAlcoholError(false);
    }
  }, [
    formik.values.medicalDetails.beer ||
      formik.values.medicalDetails.wine ||
      formik.values.medicalDetails.liquor
  ]);
  useEffect(() => {
    if (
      formik.values.medicalDetails.daily ||
      formik.values.medicalDetails.once ||
      formik.values.medicalDetails.lessThanOnce ||
      formik.values.medicalDetails.moreThanOnce
    ) {
      setfrequencyError(false);
    }
  }, [
    formik.values.medicalDetails.daily ||
      formik.values.medicalDetails.once ||
      formik.values.medicalDetails.lessThanOnce ||
      formik.values.medicalDetails.moreThanOnce
  ]);
  useLayoutEffect(() => {
    if (formik.values.medicalDetails?.measurement === "cm") {
      formik.setFieldValue("medicalDetails.height.inchFeet.inches", "");
      formik.setFieldValue("medicalDetails.height.inchFeet.feet", "");
    } else {
      formik.setFieldValue("medicalDetails.height.centimeter.cm", "");
    }
  }, [formik.values?.medicalDetails?.measurement]);

  useLayoutEffect(() => {
    if (!formik.values.medicalDetails?.familyHealthHistory) {
      formik.setFieldValue("medicalDetails", {
        ...formik.values.medicalDetails,
        familyMedicalHistory: [
          {
            familyPersonName: "",
            familyRelation: "",
            status: "Alive",
            sufferingAge: "",
            ageOfDeath: "",
            presentStateOfHealth: "",
            causeDeath: ""
          }
        ]
      });
    }
  }, [formik.values.medicalDetails?.familyHealthHistory]);

  useEffect(() => {
    if (!formik.values.medicalDetails.cigaratte) {
      formik.setFieldValue("medicalDetails.cigaratteAmount", "");
      formik.setFieldValue("medicalDetails.cigaratte", false);
    }
    if (!formik.values.medicalDetails.bidi) {
      formik.setFieldValue("medicalDetails.bidiAmount", "");
      formik.setFieldValue("medicalDetails.bidi", false);
    }
    if (!formik.values.medicalDetails.cigar) {
      formik.setFieldValue("medicalDetails.cigarAmount", "");
      formik.setFieldValue("medicalDetails.cigar", false);
    }
    if (!formik.values.medicalDetails.gutkha) {
      formik.setFieldValue("medicalDetails.gutkhaAmount", "");
      formik.setFieldValue("medicalDetails.gutkha", false);
    }
    if (!formik.values.medicalDetails.chewing) {
      formik.setFieldValue("medicalDetails.chewingAmount", "");
      formik.setFieldValue("medicalDetails.chewing", false);
    }
    if (!formik.values.medicalDetails.panMasala) {
      formik.setFieldValue("medicalDetails.panMasalaAmount", "");
      formik.setFieldValue("medicalDetails.panMasala", false);
    }
  }, [
    formik.values.medicalDetails.cigaratte,
    formik.values.medicalDetails.bidi,
    formik.values.medicalDetails.cigar,
    formik.values.medicalDetails.gutkha,
    formik.values.medicalDetails.chewing,
    formik.values.medicalDetails.panMasala
  ]);

  const handleJointLifeAddendumForm = () => {
    let smokerErr: boolean = false;
    let alcoholErr: boolean = false;
    let frequencyErr: boolean = false;
    let openErrorBox: boolean = false;
    if (
      formik.values.medicalDetails.smoker &&
      !formik.values.medicalDetails.bidi &&
      !formik.values.medicalDetails.cigaratte &&
      !formik.values.medicalDetails.gutkha &&
      !formik.values.medicalDetails.chewing &&
      !formik.values.medicalDetails.cigar &&
      !formik.values.medicalDetails.panMasala
    ) {
      setModalOpen(true);
      openErrorBox = true;
      setSmokerError(true);
      smokerErr = true;
    }
    if (
      formik.values.medicalDetails.alcohol &&
      !formik.values.medicalDetails.beer &&
      !formik.values.medicalDetails.wine &&
      !formik.values.medicalDetails.liquor
    ) {
      setModalOpen(true);
      openErrorBox = true;
      setAlcoholError(true);
      alcoholErr = true;
    }
    if (
      formik.values.medicalDetails.alcohol &&
      !formik.values.medicalDetails.moreThanOnce &&
      !formik.values.medicalDetails.once &&
      !formik.values.medicalDetails.lessThanOnce &&
      !formik.values.medicalDetails.daily
    ) {
      setModalOpen(true);
      openErrorBox = true;
      setfrequencyError(true);
      frequencyErr = true;
    }
    if (!openErrorBox) {
      setModalOpen(!formik.isValid);
    }
    if (!smokerErr && !alcoholErr && !openErrorBox && !frequencyErr && !formik.isValid) {
      if (checkMedicalField(formik.values?.medicalDetails)) formik.handleSubmit();
    } else if (!smokerErr && !alcoholErr && !openErrorBox && !frequencyErr) {
      if (checkMedicalField(formik.values?.medicalDetails)) formik.handleSubmit();
      else setOpenConfirmationModal(true);
    }
  };

  useEffect(() => {
    if ([products?.GHS, products?.GHS_FOR_JIO, products?.GHS_IDBI]?.includes(productId)) {
      formik.setFieldValue("medicalDetails.declare", false);
    }
  }, [productId]);

  useEffect(() => {
    if (!formik?.values?.medicalDetails?.otherDisease)
      formik?.setFieldValue("medicalDetails.otherDiseaseDetails", "");
  }, [formik?.values?.medicalDetails?.otherDisease]);

  return (
    <>
      {openConfirmationModal && (
        <ConfirmationModal
          text={
            <div>
              <p>
                Dear Customer, you have answered all health questions as “NO”, if you want to make
                any changes to any of the answers, please resubmit the response.
              </p>
              <p className="text-sm mt-3">If not, then please proceed further.</p>
            </div>
          }
          onNext={() => formik.handleSubmit()}
          onCancel={() => setOpenConfirmationModal(false)}
        />
      )}
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className=" bg-white pt-8 rounded-t-1.5xl">
        <MedicalAndLifestyle
          questions={medicalQuestions}
          displayAdditionalQue={toDisplayAdditionalQue}
          label="Joint Life"
          formValues={formik.values}
          setFieldValue={formik.setFieldValue}
          handleBlurs={formik.handleBlur}
          handleChanges={formik.handleChange}
          isReview={false}
          gender={jointLifeMemberDetails.gender}
          error={formik.errors}
          setFieldTouch={formik.setFieldTouched}
          touch={formik.touched}
          fieldObj="medicalDetails"
          smokerError={smokerError}
          alcoholError={alcoholError}
          frequencyError={frequencyError}
        />
        <div className="mt-10 flex justify-center">
          <Button
            variant="outlined"
            classes={{ outlined: "!rounded-lg" }}
            onClick={() => {
              store.dispatch(setStepDetails({ jointStepNo: jointStepNo - 1 }));
              window.scrollTo(0, 0);
            }}
            className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
          >
            Back
          </Button>
          <Button
            variant="contained"
            classes={{ contained: "!rounded-lg" }}
            onClick={handleJointLifeAddendumForm}
            className="!uppercase h-13 w-37.5"
          >
            NEXT
          </Button>
        </div>
      </div>
    </>
  );
}

export default memo(JoinLifeMedicalLifestyle);
